const initialState = {
  fetching: false,
  fetched: false,
  financialSheetData: [],
  resultCount: 0,
  filter: {
    deletedStatus: "NOT_DELETED",
    clientTypes: [],
    clientCRMTypes: ["CLIENT"],
    clientCRMGroup: [
      "Sociétés",
      "Indépendants",
      "Partenaire",
      "Particuliers",
      "Gérants",
      "Sociétés - Partenaire",
      "ASBL",
      "Indépendants petite entreprise",
      "AiSBL",
      "ASBL - Consultation",
      "Particuliers - Consultation",
      "Contact",
      "Gérant petite entreprise",
      "Indépendants - Consultation",
      "ASBL - Partenaire",
      "ASBL petite entreprise",
      "Fondation privée",
      "Sociétés petite entreprise"
    ],
    isEntity: "1",
    collaboratorAttribution: "ALL_FOLDERS",
    collaboratorRole: "",
    role: "",
    start: 0,
    limit: 10
  },
  error: null,
  organization: null,
  tab: null
};

export const periodFinancialSheetTreeReducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case "INIT_FINANCIAL_SHEET_TREE": {
      return {
        ...state,
        fetching: false,
        fetched: false,
        financialSheetData: [],
        error: null
      };
    }
    case "SET_FINANCIAL_SHEET_TREE_ORGANIZATION": {
      return { ...state, organization: action.organization };
    }
    case "FETCH_PERIOD_FINANCIAL_SHEET_TREE_PENDING": {
      return { ...state, fetching: true };
    }
    case "FETCH_PERIOD_FINANCIAL_SHEET_TREE_FULFILLED": {
      let data = action.payload;
      return {
        ...state,
        fetching: false,
        fetched: true,
        error: null,
        financialSheetData: data && data["result"],
        resultCount: data && data["count"],
        organization: data && action.payload.organization
      };
    }
    case "FETCH_PERIOD_FINANCIAL_SHEET_TREE_REJECTED": {
      let error = action.payload;
      switch (error.response.status) {
        case 404:
          error = {
            title: error.response.data.title,
            code: 404
          };
          break;
        default:
          error = {
            title: error.response.data.errors
              ? error.response.data.errors[0].message
              : "An error has occured",
            code: error.response.data.errors
              ? error.response.data.errors[0].code
              : 500
          };
      }
      return {
        ...state,
        fetching: false,
        financialSheetData: [],
        error
      };
    }
    case "SET_CLIENT_TYPE": {
      return {
        ...state,
        filter: { ...state.filter, clientTypes: action.clientType }
      };
    }
    case "SET_CLIENT_STATE": {
      return {
        ...state,
        filter: { ...state.filter, deletedStatus: action.clientState }
      };
    }
    case "SET_CLIENT_CRM_TYPE": {
      return {
        ...state,
        filter: { ...state.filter, clientCRMTypes: action.clientCRMTypes }
      };
    }
    case "SET_ENTITY_CLIENT_STATE": {
      return {
        ...state,
        filter: { ...state.filter, isEntity: action.entityState }
      };
    }
    case "SET_CLIENT_CRM_GROUP": {
      return {
        ...state,
        filter: { ...state.filter, clientCRMGroup: action.clientCRMGroup }
      };
    }
    case "SET_DYNAMIC_TABLE_COLLABORATOR_ROLE": {
      return {
        ...state,
        filter: { ...state.filter, collaboratorRole: action.selected }
      };
    }
    case "SET_DYNAMIC_TABLE_COLLABORATOR_ATTRIBUTION": {
      return {
        ...state,
        filter: { ...state.filter, collaboratorAttribution: action.selected }
      };
    }
    case "SET_ROLE": {
      return {
        ...state,
        filter: { ...state.filter, role: action.role }
      };
    }
    case "SET_PERIOD_FINANCIAL_SHEET_BUDGET_TAB": {
      return { ...state, tab: action.selectedTab };
    }
    case "SET_FINANCIAL_SHEET_PAGINATION_STATE": {
      return {
        ...state,
        filter: {
          ...state.filter,
          start: action.startPage * action.pageSize - action.pageSize,
          limit: action.pageSize
        }
      };
    }
    default:
      return state;
  }
};

const initialFinancialSorByState = {
  selected: "REVENUE_DESC"
};

export const financialSortByReducer = (
  state = initialFinancialSorByState,
  action
) => {
  switch (action.type) {
    case "INIT_FINANCIAL_SORT_BY": {
      return initialFinancialSorByState;
    }
    case "SET_DYNAMIC_TABLE_SORT_BY":
    case "SET_FINANCIAL_SORT_BY": {
      return {
        ...state,
        selected: action.sortBy
      };
    }
    default:
      return state;
  }
};

const initialFinancialSearchWordState = {
  searchWord: ""
};
export const financialSearchWordReducer = (
  state = initialFinancialSearchWordState,
  action
) => {
  switch (action.type) {
    case "SET_DYNAMIC_TABLE_SEARCH_WORD":
    case "SET_PERIOD_FINANCIAL_SHEET_TREE_SEARCH_WORD": {
      return {
        ...state,
        searchWord: action.searchWord
      };
    }
    default:
      return state;
  }
};

const initialExportFinancialSheetState = {
  fetching: false,
  fetched: false,
  error: null
};

export const exportFinancialSheetReducer = (
  state = initialExportFinancialSheetState,
  action
) => {
  switch (action.type) {
    case "INIT_EXPORT_FINANCIAL": {
      return initialExportFinancialSheetState;
    }
    case "EXPORT_FINANCIAL_SHEET_PENDING": {
      return { ...state, fetching: true };
    }
    case "EXPORT_FINANCIAL_SHEET_FULFILLED": {
      return {
        ...state,
        fetching: false,
        fetched: true,
        error: null
      };
    }
    case "EXPORT_FINANCIAL_SHEET_REJECTED": {
      let error = action.payload;
      switch (error.response.status) {
        case 404:
          error = {
            title: error.response.data.title,
            code: 404
          };
          break;
        default:
      }
      return {
        ...state,
        fetching: false,
        error
      };
    }
    default:
      return state;
  }
};

const initialImportFinancialSheetState = {
  fetching: false,
  fetched: false,
  error: null,
  isImportModalVisible: false,
  importAttachment: null,
  importedYear: new Date().getFullYear() + 1
};

export const importFinancialSheetReducer = (
  state = initialImportFinancialSheetState,
  action
) => {
  switch (action.type) {
    case "INIT_IMPORT_FINANCIAL": {
      return initialImportFinancialSheetState;
    }
    case "IMPORT_FINANCIAL_SHEET_PENDING": {
      return { ...state, fetching: true };
    }
    case "IMPORT_FINANCIAL_SHEET_FULFILLED": {
      return {
        ...state,
        fetching: false,
        fetched: true,
        error: null
      };
    }
    case "IMPORT_FINANCIAL_SHEET_REJECTED": {
      let error = action.payload;
      switch (error.response.status) {
        case 404:
          error = {
            title: error.response.data.title,
            code: 404
          };
          break;
        default:
      }
      return {
        ...state,
        fetching: false,
        error
      };
    }
    case "SET_IMPORT_FINANCIAL_MODAL": {
      return {
        ...state,
        isImportModalVisible: action.visible
      };
    }
    case "SET_IMPORT_ATTACHMENT": {
      return { ...state, importAttachment: action.importAttachment };
    }
    case "SET_FINANCIAL_IMPORTED_YEAR": {
      return { ...state, importedYear: action.year };
    }
    default:
      return state;
  }
};
export const exportTimeSheetReducer = (
  state = initialExportFinancialSheetState,
  action
) => {
  switch (action.type) {
    case "EXPORT_TIME_SHEET_PENDING": {
      return { ...state, fetching: true };
    }
    case "EXPORT_TIME_SHEET_FULFILLED": {
      return {
        ...state,
        fetching: false,
        fetched: true,
        error: null
      };
    }
    case "EXPORT_TIME_SHEET_REJECTED": {
      let error = action.payload;
      switch (error.response.status) {
        case 404:
          error = {
            title: error.response.data.title,
            code: 404
          };
          break;
        default:
      }
      return {
        ...state,
        fetching: false,
        error
      };
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/financial-sheet-tree.js